document.addEventListener('DOMContentLoaded', () => {
  
    // =========================================
    // 1. CAROUSEL SLIDER LOGIC
    // =========================================
    const initSliders = () => {
      const sliders = document.querySelectorAll('.movnw-slider-wrapper');
  
      sliders.forEach(container => {
        if (container.dataset.initialized === 'true') return;
        container.dataset.initialized = 'true';
  
        const slider = container.querySelector('.movnw-slider-window');
        const track = container.querySelector('.movnw-slider-track');
        const slides = container.querySelectorAll('.movnw-slide');
        const dots = container.querySelectorAll('.hero-dot');
        const arrowPrev = container.querySelector('.hero-nav--prev');
        const arrowNext = container.querySelector('.hero-nav--next');
  
        if (!slides.length) return;
  
        let currentIndex = 0;
  
        track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
  
        function updateSlide(index) {
          if (index < 0) index = slides.length - 1;
          if (index >= slides.length) index = 0;
  
          currentIndex = index;
          track.style.transform = `translateX(-${currentIndex * 100}%)`;
  
          if (dots.length) {
            dots.forEach(d => d.classList.remove('is-active'));
            if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
          }
        }
  
        // --- Touch & Mouse Logic ---
        let startX = 0;
        let isDragging = false;
        let isHorizontalSwipe = false;
        let isDirectionDetermined = false;
        let isClickAllowed = true; // Flag to distinguish click vs drag
        let startY = 0;
  
        const onTouchStart = (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          isDragging = true;
          isDirectionDetermined = false;
          isClickAllowed = true; 
          track.style.transition = 'none';
        };
  
        const onTouchMove = (e) => {
          if (!isDragging) return;
          const currentX = e.touches[0].clientX;
          const currentY = e.touches[0].clientY;
          const diffX = currentX - startX;
          const diffY = currentY - startY;
  
          if (Math.abs(diffX) > 5) {
            isClickAllowed = false;
          }
  
          if (!isDirectionDetermined) {
            if (Math.abs(diffX) < 5 && Math.abs(diffY) < 5) return;
            isDirectionDetermined = true;
            if (Math.abs(diffX) > Math.abs(diffY)) {
              isHorizontalSwipe = true;
            } else {
              isHorizontalSwipe = false;
              track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
            }
          }
  
          if (isHorizontalSwipe) {
            e.stopPropagation();
            if (e.cancelable) e.preventDefault();
            const slideWidth = slider.offsetWidth;
            const currentOffset = -currentIndex * slideWidth;
            track.style.transform = `translateX(${currentOffset + diffX}px)`;
          }
        };
  
        const onEndDrag = (e) => {
          if (!isDragging) return;
          isDragging = false;
          track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
  
          if (!isHorizontalSwipe) {
            track.style.transform = `translateX(-${currentIndex * 100}%)`;
            return;
          }
  
          const endX = (e.type.includes('touch')) ? e.changedTouches[0].clientX : e.clientX;
          const diffX = endX - startX;
          const threshold = 50;
  
          if (diffX > threshold) updateSlide(currentIndex - 1);
          else if (diffX < -threshold) updateSlide(currentIndex + 1);
          else updateSlide(currentIndex);
        };
  
        slider.addEventListener('touchstart', onTouchStart, { passive: true });
        slider.addEventListener('touchmove', onTouchMove, { passive: false });
        slider.addEventListener('touchend', onEndDrag);
  
        slider.addEventListener('mousedown', (e) => {
          startX = e.clientX;
          isDragging = true;
          isHorizontalSwipe = true;
          isClickAllowed = true;
          track.style.transition = 'none';
          e.preventDefault();
        });
  
        slider.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          e.preventDefault();
          const diffX = e.clientX - startX;
          if (Math.abs(diffX) > 5) isClickAllowed = false;
          const slideWidth = slider.offsetWidth;
          const currentOffset = -currentIndex * slideWidth;
          track.style.transform = `translateX(${currentOffset + diffX}px)`;
        });
  
        slider.addEventListener('mouseup', onEndDrag);
        slider.addEventListener('mouseleave', onEndDrag);
  
        // Intercept Click if Dragged
        slider.addEventListener('click', (e) => {
          if (!isClickAllowed) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, { capture: true });
  
        // Controls
        if (arrowPrev) {
          arrowPrev.addEventListener('click', (e) => {
            e.stopPropagation();
            updateSlide(currentIndex - 1);
          });
        }
        if (arrowNext) {
          arrowNext.addEventListener('click', (e) => {
            e.stopPropagation();
            updateSlide(currentIndex + 1);
          });
        }
        if (dots.length) {
          dots.forEach((dot, idx) => {
            dot.addEventListener('click', (e) => {
              e.stopPropagation();
              updateSlide(idx);
            });
          });
        }
      });
    };
  
    // =========================================
    // 2. LIGHTBOX SLIDER LOGIC
    // =========================================
    const initLightbox = () => {
      const lightbox = document.getElementById('movnw-lightbox');
      const detailsWrapper = document.querySelector('.movnw-details-wrapper');
      
      // Safety check
      if (!lightbox || !detailsWrapper) return;
      
      // Read the mode setting
      const lightboxMode = detailsWrapper.getAttribute('data-lightbox-mode') || 'joined';
  
      // Select all potential triggers
      // Stack Images
      const stackImages = Array.from(document.querySelectorAll('.movnw-image-stack-item img'));
      // Carousel Images
      const carouselImages = Array.from(document.querySelectorAll('.movnw-slide img'));
      
      // Combine all for event binding
      const allImages = [...stackImages, ...carouselImages];
  
      if (!allImages.length) return;
      
      // Prevent double init
      if (lightbox.dataset.initialized === 'true') return;
      lightbox.dataset.initialized = 'true';
  
      const track = lightbox.querySelector('.movnw-lightbox-track');
      const closeBtn = lightbox.querySelector('.movnw-lightbox-close');
      const prevBtn = lightbox.querySelector('.movnw-lightbox-prev');
      const nextBtn = lightbox.querySelector('.movnw-lightbox-next');
      const wrapper = lightbox.querySelector('.movnw-lightbox-wrapper');
      const pagination = lightbox.querySelector('.movnw-lightbox-pagination'); 
  
      let lightboxIndex = 0;
      let lightboxDots = [];
      let currentSlidesList = []; // The list of images currently active in the lightbox
  
      // Helper: Build Lightbox for specific image list
      const buildLightboxSlides = (imagesList, startIndex) => {
          track.innerHTML = '';
          pagination.innerHTML = '';
          lightboxDots = [];
          currentSlidesList = imagesList;
          lightboxIndex = startIndex;
  
          imagesList.forEach((img, idx) => {
              // 1. Create Slide
              const slide = document.createElement('div');
              slide.classList.add('movnw-lightbox-slide');
              const slideImg = document.createElement('img');
              slideImg.src = img.src.replace('width=1400', 'width=3000').replace('width=1200', 'width=3000');
              slideImg.draggable = false; 
              slide.appendChild(slideImg);
              track.appendChild(slide);
  
              // 2. Create Dot
              const dot = document.createElement('button');
              dot.classList.add('movnw-lightbox-dot');
              dot.setAttribute('aria-label', `Go to slide ${idx + 1}`);
              dot.addEventListener('click', (e) => {
                  e.stopPropagation();
                  updateLightbox(idx);
              });
              pagination.appendChild(dot);
              lightboxDots.push(dot);
          });
      };
  
      // Bind Click Events
      allImages.forEach((img) => {
          img.addEventListener('click', (e) => {
              // Determine which set of images to show
              let targetList = [];
              let targetIndex = 0;
  
              if (lightboxMode === 'separate') {
                  if (stackImages.includes(img)) {
                      targetList = stackImages;
                      targetIndex = stackImages.indexOf(img);
                  } else if (carouselImages.includes(img)) {
                      targetList = carouselImages;
                      targetIndex = carouselImages.indexOf(img);
                  }
              } else {
                  // Joined Mode (Default)
                  // Combine them in DOM order usually: Stack first, then Carousel
                  targetList = [...stackImages, ...carouselImages];
                  targetIndex = targetList.indexOf(img);
              }
  
              if (targetList.length > 0) {
                  buildLightboxSlides(targetList, targetIndex);
                  openLightbox();
              }
          });
      });
  
      // --- Control Functions ---
      function openLightbox() {
         updateLightbox(lightboxIndex, false); // No animation on open
         lightbox.classList.add('active');
         document.body.style.overflow = 'hidden';
      }
  
      function closeLightbox() {
         lightbox.classList.remove('active');
         document.body.style.overflow = '';
      }
  
      function updateLightbox(index, animate = true) {
         lightboxIndex = index;
         
         // Loop logic
         const totalSlides = currentSlidesList.length;
         if (totalSlides === 0) return;
  
         if (lightboxIndex < 0) lightboxIndex = totalSlides - 1;
         if (lightboxIndex >= totalSlides) lightboxIndex = 0;
  
         if (animate) {
             track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
         } else {
             track.style.transition = 'none';
         }
         track.style.transform = `translateX(-${lightboxIndex * 100}%)`;
  
         // Update Dots
         lightboxDots.forEach(d => d.classList.remove('is-active'));
         if (lightboxDots[lightboxIndex]) lightboxDots[lightboxIndex].classList.add('is-active');
      }
  
      function nextSlide() {
         updateLightbox(lightboxIndex + 1);
      }
  
      function prevSlide() {
         updateLightbox(lightboxIndex - 1);
      }
  
      // --- Event Listeners ---
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); prevSlide(); });
      if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); nextSlide(); });
      
      lightbox.addEventListener('click', function(e) {
        if (e.target === lightbox || e.target === wrapper) {
          closeLightbox();
        }
      });
      
      document.addEventListener('keydown', function(e) {
        if (!lightbox.classList.contains('active')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') nextSlide();
        if (e.key === 'ArrowLeft') prevSlide();
      });
  
      // --- Swipe / Drag Logic (Reused Pattern) ---
      let startX = 0;
      let isDragging = false;
      let isHorizontalSwipe = false;
      let isDirectionDetermined = false;
      let startY = 0;
  
      const lbTouchStart = (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
        isDirectionDetermined = false;
        track.style.transition = 'none';
      };
  
      const lbTouchMove = (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const diffX = currentX - startX;
        const diffY = currentY - startY;
  
        if (!isDirectionDetermined) {
          if (Math.abs(diffX) < 5 && Math.abs(diffY) < 5) return;
          isDirectionDetermined = true;
          if (Math.abs(diffX) > Math.abs(diffY)) isHorizontalSwipe = true;
          else isHorizontalSwipe = false;
        }
  
        if (isHorizontalSwipe) {
          e.stopPropagation();
          if(e.cancelable) e.preventDefault();
          const slideWidth = wrapper.offsetWidth;
          const currentOffset = -lightboxIndex * slideWidth;
          track.style.transform = `translateX(${currentOffset + diffX}px)`;
        }
      };
  
      const lbEndDrag = (e) => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
        
        if (!isHorizontalSwipe) {
           track.style.transform = `translateX(-${lightboxIndex * 100}%)`;
           return;
        }
  
        const endX = (e.type.includes('touch')) ? e.changedTouches[0].clientX : e.clientX;
        const diffX = endX - startX;
        const threshold = 50;
  
        if (diffX > threshold) prevSlide();
        else if (diffX < -threshold) nextSlide();
        else updateLightbox(lightboxIndex); 
      };
  
      wrapper.addEventListener('touchstart', lbTouchStart, { passive: true });
      wrapper.addEventListener('touchmove', lbTouchMove, { passive: false });
      wrapper.addEventListener('touchend', lbEndDrag);
  
      // Mouse Events
      wrapper.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        isDragging = true;
        isHorizontalSwipe = true;
        track.style.transition = 'none';
        e.preventDefault();
      });
  
      wrapper.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const diffX = e.clientX - startX;
        const slideWidth = wrapper.offsetWidth;
        const currentOffset = -lightboxIndex * slideWidth;
        track.style.transform = `translateX(${currentOffset + diffX}px)`;
      });
  
      wrapper.addEventListener('mouseup', lbEndDrag);
      wrapper.addEventListener('mouseleave', lbEndDrag);
    };
  
    // --- INITIALIZE ALL ---
    initSliders();
    initLightbox();
  
    // Shopify Theme Editor Support
    document.addEventListener('shopify:section:load', () => {
      initSliders();
      initLightbox();
    });
  });